// @ts-nocheck
import React, { memo, useState, useCallback } from 'react';
import { Handle, Position, NodeResizer } from 'reactflow';
import { apiPatch } from '../../../utils/apiClient';
import { logger } from '../../../utils/logger';
import type { StickyNoteNodeProps } from '../../../types/canvas';
import './StickyNoteNode.css';

/**
 * 便利贴节点
 * 支持不同颜色的便签，双击编辑
 */
const StickyNoteNode: React.FC<StickyNoteNodeProps> = ({ data, selected }) => {
  const text = data.content?.content;
  const color = data.content?.color || 'yellow';
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState(text || '');

  const handleDoubleClick = useCallback(() => {
    setIsEditing(true);
    setEditText(text || '');
  }, [text]);

  const handleBlur = useCallback(async () => {
    setIsEditing(false);
    if (editText !== text) {
      try {
        await apiPatch(`/api/blocks/${data.blockId}`, {
          content: {
            ...data.content,
            content: editText
          }
        });
        logger.log('✅ 便签已更新');
      } catch (err) {
        console.error('❌ 更新便签失败:', err);
        setEditText(text || '');
      }
    }
  }, [editText, text, data]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      (e.target as HTMLTextAreaElement).blur();
    }
    if (e.key === 'Escape') {
      setEditText(text || '');
      setIsEditing(false);
    }
  }, [text]);

  return (
    <div
      className={`sticky-note-node ${selected ? 'selected' : ''}`}
      data-color={color}
    >
      <NodeResizer
        color="#1a73e8"
        isVisible={selected}
        minWidth={150}
        minHeight={100}
      />
      <Handle type="target" position={Position.Top} className="node-handle" />

      <div className="sticky-note-header">
        <span className="note-icon">📌</span>
      </div>

      <div className="sticky-note-content" onDoubleClick={handleDoubleClick}>
        {isEditing ? (
          <textarea
            className="note-textarea"
            value={editText}
            onChange={(e) => setEditText(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        ) : (
          <p>{text || '双击编辑便签...'}</p>
        )}
      </div>

      <Handle type="source" position={Position.Bottom} className="node-handle" />
    </div>
  );
};

export default memo(StickyNoteNode);
